const salaryTableStrings = {
  removingSalaryDenial: "Honoraret kan ikke fjernes fordi honorarbrøk er i bruk på kravet"
};

export default salaryTableStrings;